export function common() {
  const header = document.getElementById("js-header");

  if (!header) return; // 要素が存在しない場合は処理を終了

  const headerScroll = () => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 1 && window.innerWidth > 768) {
        header.classList.add("is-scroll");
      } else {
        header.classList.remove("is-scroll");
      }
    });
  };

  headerScroll();
}


//SPサイズのお問い合わせボタン
document.addEventListener("DOMContentLoaded", function () {
  let button = document.querySelector(".c-button07");
  let mv = document.querySelector(".c-mv") || document.querySelector(".p-mv-lower");

  if (!button || !mv) return;

  function toggleButtonVisibility() {
    const mvRect = mv.getBoundingClientRect();
    if (mvRect.bottom <= 0) {
      button.classList.add("_is-show");
    } else {
      button.classList.remove("_is-show");
    }
  }

  window.addEventListener("scroll", toggleButtonVisibility);
  toggleButtonVisibility();
});
